import React from 'react';
import { Link } from 'react-router-dom';

const lightThemeLogo =
  'https://media-manager-c.questera.ai/greta-media/ab03ff55dc7bcdd9e4a34a93308a2aa656b3e0baf34844f0be8f244dd21175025656600d9573a40a26a1591403a49a1d/images/aW1hZ2UvcG5n/3173dd3df376b5efaa70d50d21a5a703.png';
const darkThemeLogo =
  'https://media-manager-c.questera.ai/greta-media/ab03ff55dc7bcdd9e4a34a93308a2aa656b3e0baf34844f0be8f244dd21175025656600d9573a40a26a1591403a49a1d/images/aW1hZ2UvcG5n/16b1dc67cd5233938dad367d39c6d8c8.png';

function Brand({ footer = false }) {
  const logo = footer ? darkThemeLogo : lightThemeLogo;

  return (
    <Link
      className={`brand brand-logo ${footer ? 'brand-footer' : ''}`}
      to="/"
      aria-label="OpiniGuru home"
    >
      <img
        src={logo}
        alt="OpiniGuru — Where opinions, news and forums unite"
      />
    </Link>
  );
}

export default Brand;